export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

// Jedinstven broj redova po stranici za sve tabele (server-side paginacija).
export const PAGE_SIZE = 10;
